import React,{useState, useEffect} from "react"
import { Form,Dropdown,ButtonGroup } from "react-bootstrap";
// styles
import "./FilterBlock.scss"

// markup
const FilterBlock = () => {

  const [arrow, setArrow] = useState(false);
  const [filter, setFilter] = useState(false);

  const filterRefine =()=>{
    setFilter(!filter)
  }

  const arrowClick=()=>{
    setArrow(!arrow)
  }
 
  return (

  <React.Fragment>
  <div className={filter ? "filter-section " : "filter-section refine"}>
    <div className="filter-section-heading d-xl-none refine-search">
    <h2  onClick={filterRefine}>Refine Your Search <i className="icon-angle-down-big-white"></i></h2>
    </div>
    <Form>
      <div className="filter-group">
      <div className="filter-search">
        <div className="filter-search-field filter-search-area">
        <i class="search-icon"></i>
          <Form.Control type="search" placeholder="Project name or area"/>
        </div>
        <div className="filter-search-field">
          <Form.Control type="search" placeholder="Search by keyword"/>
        </div>
      </div>
      <div className="filter-select">
        <div className="filter-select-field">
                <Dropdown>
                  <Dropdown.Toggle variant="link"> Price Range</Dropdown.Toggle>
                  
                   <Dropdown.Menu>
                  <Dropdown.Item>Price Range</Dropdown.Item>
                  <Dropdown.Item >Price Rangen</Dropdown.Item>
                  <Dropdown.Item>Price Range</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            
        </div>
        <div className="filter-select-field filter-select-width">
        <Dropdown>
                  <Dropdown.Toggle variant="link"> Bed</Dropdown.Toggle>
                  
                   <Dropdown.Menu>
                  <Dropdown.Item>Bed 1</Dropdown.Item>
                  <Dropdown.Item >Bed 2</Dropdown.Item>
                  <Dropdown.Item>Bed 3</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
        </div>
        <div className="filter-select-field">
        <Dropdown>
                  <Dropdown.Toggle variant="link"> Property Type</Dropdown.Toggle>
                  
                   <Dropdown.Menu>
                  <Dropdown.Item>Property Type</Dropdown.Item>
                  <Dropdown.Item >Property Type</Dropdown.Item>
                  <Dropdown.Item>Property Type</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
             
        </div>
      </div>
      </div>

      <div className="search-result-short">
        <div className="search-result-title">
        <h1><strong>38</strong> Properties for sale Arabian Ranches, Dubai</h1>
        </div>
        <div className="filter-short">
        <div className="switch-button ">
                  <label for="toggle-button">
                    <input type="checkbox" id="toggle-button" />
                    <span className="toggle-switch">
                      <span className="toggle-switch-bar"></span>
                    </span>
                    <span className="toggle-text">Include Sold</span>
                  </label>
          </div>
          <div className="price-short-filter"  onClick={arrowClick}>
            <i className={arrow ? "short-icon short-icon-low" : "short-icon"}></i>
            <span className="toggle-text">{arrow ? " Lowest" : " Highest"} Price</span>
          </div>

        </div>
      </div>
    </Form>
  </div>
    </React.Fragment>
  )
}

export default FilterBlock